export const TOKEN_ACCESS = 'TOKEN_ACCESS';
// export const TOKEN_EXPIRE = 'TOKEN_EXPIRE';
// export const TOKEN_REFRESH = 'TOKEN_REFRESH';
// export const TOKEN_USER = 'TOKEN_USER';
// export const PUSH_TOKEN = 'pushTokenDividendos';
export const PRODUCT_ID = 'PRODUCT_ID';

export * from './general';